/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _map from 'lodash/map'

export enum ChannelStatusEnum {
  不生效 = 0,
  生效 = 1,
}

export enum ChannelTypeEnum {
  官方 = 0,
  周卡 = 1,
  华为 = 2,
  第三方 = 3,
  薪资转金币 = 4,
}

export interface ProductsListInterface {
  list: Array<any>
  coins: number
  last_coins_stage: number
  is_ra_customer: boolean
  countries: Array<{
    code: number
    name: string
    flag: string
  }>
  default_country: {
    code: number
    name: string
    flag: string
  }
  is_white_tag?: boolean
  has_third_pay?: boolean
  has_week_card: boolean
}

interface InitialStateType {
  wallet?: Partial<ProductsListInterface>
}
const initialState: InitialStateType = {
  wallet: {
    list: [],
    last_coins_stage: 0,
    coins: 0,
    is_ra_customer: false,
    countries: [],
    default_country: {
      code: 0,
      name: '',
      flag: '',
    },
    has_week_card: false,
  },
}

export const createRechargeOrderV2 = createAsyncThunk(
  'OffSiteRecharge/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const {otherInfo, deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/pay/create_order_from_external_recharge',
      {
        ...otherInfo,
        ...params,
        mid: otherInfo.h_m || deviceinfo.h_m,
        is_from_external: !deviceinfo?.h_m,
      },
      {
        store,
        // xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const getProductsList = createAsyncThunk(
  'OffSiteRecharge/getProductsList',
  async (params: any = {}, store: any) => {
    const {otherInfo, deviceinfo} = store.getState().env
    // '/live/pay/get_products_list_v2',
    const resp = await http.post(
      '/live/pay/get_external_recharge_products_list',
      {
        ...otherInfo,
        ...params,
        is_from_external: !deviceinfo?.h_m,
        before_recharged: 1,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const send_external_recharge_code = createAsyncThunk(
  'OffSiteRecharge/send_external_recharge_code',
  async (params: any, store: any) => {
    const {otherInfo, deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/pay/send_external_recharge_code',
      {
        ...otherInfo,
        ...params,
        is_from_external: !deviceinfo?.h_m,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const check_external_recharge_code = createAsyncThunk(
  'OffSiteRecharge/check_external_recharge_code',
  async (params: any, store: any) => {
    const {otherInfo, deviceinfo} = store.getState().env
    const resp = await http.post(
      '/live/pay/check_external_recharge_code',
      {
        ...otherInfo,
        ...params,
        is_from_external: !deviceinfo?.h_m,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const NewHiyaWalletSlice = createSlice({
  name: 'OffSiteRecharge',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const res = action.payload
      const list = _map(res?.list, (item) => {
        return {
          ...item,
          // 列表里的currency和ThirdPartyPaySt里不一致时，用列表里的currency覆盖ThirdPartyPaySt的currency
          list: _map(item?.list, (li: any) => {
            if (li?.currency !== item?.currency) {
              li.currency = item.currency
            }
            return li
          }),
        }
      })
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...res, list})
    })
  },
})
export default NewHiyaWalletSlice.reducer
export const NewHiyaWalletAction = NewHiyaWalletSlice.actions
